import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLocale } from '../../context/LocaleContext';
import { toast } from 'react-toastify';

// GCC / common codes shown first, then the rest alphabetically by name
const countryCodes = [
  { code: '+974', country: 'QA', name: 'Qatar' },
  { code: '+971', country: 'AE', name: 'United Arab Emirates' },
  { code: '+966', country: 'SA', name: 'Saudi Arabia' },
  { code: '+965', country: 'KW', name: 'Kuwait' },
  { code: '+973', country: 'BH', name: 'Bahrain' },
  { code: '+968', country: 'OM', name: 'Oman' },

  { code: '+93', country: 'AF', name: 'Afghanistan' },
  { code: '+355', country: 'AL', name: 'Albania' },
  { code: '+213', country: 'DZ', name: 'Algeria' },
  { code: '+376', country: 'AD', name: 'Andorra' },
  { code: '+244', country: 'AO', name: 'Angola' },
  { code: '+54', country: 'AR', name: 'Argentina' },
  { code: '+374', country: 'AM', name: 'Armenia' },
  { code: '+61', country: 'AU', name: 'Australia' },
  { code: '+43', country: 'AT', name: 'Austria' },
  { code: '+994', country: 'AZ', name: 'Azerbaijan' },
  { code: '+1242', country: 'BS', name: 'Bahamas' },
  { code: '+880', country: 'BD', name: 'Bangladesh' },
  { code: '+1246', country: 'BB', name: 'Barbados' },
  { code: '+375', country: 'BY', name: 'Belarus' },
  { code: '+32', country: 'BE', name: 'Belgium' },
  { code: '+501', country: 'BZ', name: 'Belize' },
  { code: '+229', country: 'BJ', name: 'Benin' },
  { code: '+975', country: 'BT', name: 'Bhutan' },
  { code: '+591', country: 'BO', name: 'Bolivia' },
  { code: '+387', country: 'BA', name: 'Bosnia and Herzegovina' },
  { code: '+267', country: 'BW', name: 'Botswana' },
  { code: '+55', country: 'BR', name: 'Brazil' },
  { code: '+673', country: 'BN', name: 'Brunei' },
  { code: '+359', country: 'BG', name: 'Bulgaria' },
  { code: '+226', country: 'BF', name: 'Burkina Faso' },
  { code: '+257', country: 'BI', name: 'Burundi' },
  { code: '+855', country: 'KH', name: 'Cambodia' },
  { code: '+237', country: 'CM', name: 'Cameroon' },
  { code: '+1', country: 'CA', name: 'Canada' },
  { code: '+238', country: 'CV', name: 'Cape Verde' },
  { code: '+236', country: 'CF', name: 'Central African Republic' },
  { code: '+235', country: 'TD', name: 'Chad' },
  { code: '+56', country: 'CL', name: 'Chile' },
  { code: '+86', country: 'CN', name: 'China' },
  { code: '+57', country: 'CO', name: 'Colombia' },
  { code: '+269', country: 'KM', name: 'Comoros' },
  { code: '+242', country: 'CG', name: 'Congo' },
  { code: '+243', country: 'CD', name: 'Congo (DRC)' },
  { code: '+506', country: 'CR', name: 'Costa Rica' },
  { code: '+225', country: 'CI', name: "Côte d'Ivoire" },
  { code: '+385', country: 'HR', name: 'Croatia' },
  { code: '+53', country: 'CU', name: 'Cuba' },
  { code: '+357', country: 'CY', name: 'Cyprus' },
  { code: '+420', country: 'CZ', name: 'Czechia' },
  { code: '+45', country: 'DK', name: 'Denmark' },
  { code: '+253', country: 'DJ', name: 'Djibouti' },
  { code: '+1767', country: 'DM', name: 'Dominica' },
  { code: '+1809', country: 'DO', name: 'Dominican Republic' },
  { code: '+593', country: 'EC', name: 'Ecuador' },
  { code: '+20', country: 'EG', name: 'Egypt' },
  { code: '+503', country: 'SV', name: 'El Salvador' },
  { code: '+240', country: 'GQ', name: 'Equatorial Guinea' },
  { code: '+291', country: 'ER', name: 'Eritrea' },
  { code: '+372', country: 'EE', name: 'Estonia' },
  { code: '+268', country: 'SZ', name: 'Eswatini' },
  { code: '+251', country: 'ET', name: 'Ethiopia' },
  { code: '+679', country: 'FJ', name: 'Fiji' },
  { code: '+358', country: 'FI', name: 'Finland' },
  { code: '+33', country: 'FR', name: 'France' },
  { code: '+241', country: 'GA', name: 'Gabon' },
  { code: '+220', country: 'GM', name: 'Gambia' },
  { code: '+995', country: 'GE', name: 'Georgia' },
  { code: '+49', country: 'DE', name: 'Germany' },
  { code: '+233', country: 'GH', name: 'Ghana' },
  { code: '+30', country: 'GR', name: 'Greece' },
  { code: '+1473', country: 'GD', name: 'Grenada' },
  { code: '+502', country: 'GT', name: 'Guatemala' },
  { code: '+224', country: 'GN', name: 'Guinea' },
  { code: '+245', country: 'GW', name: 'Guinea-Bissau' },
  { code: '+592', country: 'GY', name: 'Guyana' },
  { code: '+509', country: 'HT', name: 'Haiti' },
  { code: '+504', country: 'HN', name: 'Honduras' },
  { code: '+852', country: 'HK', name: 'Hong Kong' },
  { code: '+36', country: 'HU', name: 'Hungary' },
  { code: '+354', country: 'IS', name: 'Iceland' },
  { code: '+91', country: 'IN', name: 'India' },
  { code: '+62', country: 'ID', name: 'Indonesia' },
  { code: '+98', country: 'IR', name: 'Iran' },
  { code: '+964', country: 'IQ', name: 'Iraq' },
  { code: '+353', country: 'IE', name: 'Ireland' },
  { code: '+972', country: 'IL', name: 'Israel' },
  { code: '+39', country: 'IT', name: 'Italy' },
  { code: '+1876', country: 'JM', name: 'Jamaica' },
  { code: '+81', country: 'JP', name: 'Japan' },
  { code: '+962', country: 'JO', name: 'Jordan' },
  { code: '+7', country: 'KZ', name: 'Kazakhstan' },
  { code: '+254', country: 'KE', name: 'Kenya' },
  { code: '+383', country: 'XK', name: 'Kosovo' },
  { code: '+996', country: 'KG', name: 'Kyrgyzstan' },
  { code: '+856', country: 'LA', name: 'Laos' },
  { code: '+371', country: 'LV', name: 'Latvia' },
  { code: '+961', country: 'LB', name: 'Lebanon' },
  { code: '+266', country: 'LS', name: 'Lesotho' },
  { code: '+231', country: 'LR', name: 'Liberia' },
  { code: '+218', country: 'LY', name: 'Libya' },
  { code: '+423', country: 'LI', name: 'Liechtenstein' },
  { code: '+370', country: 'LT', name: 'Lithuania' },
  { code: '+352', country: 'LU', name: 'Luxembourg' },
  { code: '+853', country: 'MO', name: 'Macau' },
  { code: '+261', country: 'MG', name: 'Madagascar' },
  { code: '+265', country: 'MW', name: 'Malawi' },
  { code: '+60', country: 'MY', name: 'Malaysia' },
  { code: '+960', country: 'MV', name: 'Maldives' },
  { code: '+223', country: 'ML', name: 'Mali' },
  { code: '+356', country: 'MT', name: 'Malta' },
  { code: '+222', country: 'MR', name: 'Mauritania' },
  { code: '+230', country: 'MU', name: 'Mauritius' },
  { code: '+52', country: 'MX', name: 'Mexico' },
  { code: '+373', country: 'MD', name: 'Moldova' },
  { code: '+377', country: 'MC', name: 'Monaco' },
  { code: '+976', country: 'MN', name: 'Mongolia' },
  { code: '+382', country: 'ME', name: 'Montenegro' },
  { code: '+212', country: 'MA', name: 'Morocco' },
  { code: '+258', country: 'MZ', name: 'Mozambique' },
  { code: '+95', country: 'MM', name: 'Myanmar' },
  { code: '+264', country: 'NA', name: 'Namibia' },
  { code: '+977', country: 'NP', name: 'Nepal' },
  { code: '+31', country: 'NL', name: 'Netherlands' },
  { code: '+64', country: 'NZ', name: 'New Zealand' },
  { code: '+505', country: 'NI', name: 'Nicaragua' },
  { code: '+227', country: 'NE', name: 'Niger' },
  { code: '+234', country: 'NG', name: 'Nigeria' },
  { code: '+850', country: 'KP', name: 'North Korea' },
  { code: '+389', country: 'MK', name: 'North Macedonia' },
  { code: '+47', country: 'NO', name: 'Norway' },
  { code: '+92', country: 'PK', name: 'Pakistan' },
  { code: '+970', country: 'PS', name: 'Palestine' },
  { code: '+507', country: 'PA', name: 'Panama' },
  { code: '+675', country: 'PG', name: 'Papua New Guinea' },
  { code: '+595', country: 'PY', name: 'Paraguay' },
  { code: '+51', country: 'PE', name: 'Peru' },
  { code: '+63', country: 'PH', name: 'Philippines' },
  { code: '+48', country: 'PL', name: 'Poland' },
  { code: '+351', country: 'PT', name: 'Portugal' },
  { code: '+1787', country: 'PR', name: 'Puerto Rico' },
  { code: '+40', country: 'RO', name: 'Romania' },
  { code: '+7', country: 'RU', name: 'Russia' },
  { code: '+250', country: 'RW', name: 'Rwanda' },
  { code: '+378', country: 'SM', name: 'San Marino' },
  { code: '+221', country: 'SN', name: 'Senegal' },
  { code: '+381', country: 'RS', name: 'Serbia' },
  { code: '+248', country: 'SC', name: 'Seychelles' },
  { code: '+232', country: 'SL', name: 'Sierra Leone' },
  { code: '+65', country: 'SG', name: 'Singapore' },
  { code: '+421', country: 'SK', name: 'Slovakia' },
  { code: '+386', country: 'SI', name: 'Slovenia' },
  { code: '+252', country: 'SO', name: 'Somalia' },
  { code: '+27', country: 'ZA', name: 'South Africa' },
  { code: '+82', country: 'KR', name: 'South Korea' },
  { code: '+211', country: 'SS', name: 'South Sudan' },
  { code: '+34', country: 'ES', name: 'Spain' },
  { code: '+94', country: 'LK', name: 'Sri Lanka' },
  { code: '+249', country: 'SD', name: 'Sudan' },
  { code: '+597', country: 'SR', name: 'Suriname' },
  { code: '+46', country: 'SE', name: 'Sweden' },
  { code: '+41', country: 'CH', name: 'Switzerland' },
  { code: '+963', country: 'SY', name: 'Syria' },
  { code: '+886', country: 'TW', name: 'Taiwan' },
  { code: '+992', country: 'TJ', name: 'Tajikistan' },
  { code: '+255', country: 'TZ', name: 'Tanzania' },
  { code: '+66', country: 'TH', name: 'Thailand' },
  { code: '+228', country: 'TG', name: 'Togo' },
  { code: '+1868', country: 'TT', name: 'Trinidad and Tobago' },
  { code: '+216', country: 'TN', name: 'Tunisia' },
  { code: '+90', country: 'TR', name: 'Turkey' },
  { code: '+993', country: 'TM', name: 'Turkmenistan' },
  { code: '+256', country: 'UG', name: 'Uganda' },
  { code: '+380', country: 'UA', name: 'Ukraine' },
  { code: '+44', country: 'GB', name: 'United Kingdom' },
  { code: '+1', country: 'US', name: 'United States' },
  { code: '+598', country: 'UY', name: 'Uruguay' },
  { code: '+998', country: 'UZ', name: 'Uzbekistan' },
  { code: '+58', country: 'VE', name: 'Venezuela' },
  { code: '+84', country: 'VN', name: 'Vietnam' },
  { code: '+967', country: 'YE', name: 'Yemen' },
  { code: '+260', country: 'ZM', name: 'Zambia' },
  { code: '+263', country: 'ZW', name: 'Zimbabwe' },
];

// Flag image (flagcdn) — renders real flags on every OS, unlike emoji flags
const Flag = ({ country, className = '' }) => (
  <img
    src={`https://flagcdn.com/w40/${country.toLowerCase()}.png`}
    srcSet={`https://flagcdn.com/w80/${country.toLowerCase()}.png 2x`}
    alt={country}
    className={`inline-block w-5 h-auto rounded-sm shrink-0 ${className}`}
    loading="lazy"
  />
);

const Register = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    password: '',
    password_confirmation: ''
  });
  const [selectedIso, setSelectedIso] = useState('QA'); // Qatar by default
  const [codeMenuOpen, setCodeMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const codeMenuRef = useRef(null);
  const { register } = useAuth();
  const { t, dir } = useLocale();
  const navigate = useNavigate();

  // Track the country by ISO (unique) since several share a dial code (+1, +7)
  const selectedCountry = countryCodes.find((c) => c.country === selectedIso) || countryCodes[0];
  const countryCode = selectedCountry.code;

  // Close the country-code dropdown when clicking/tapping outside it
  useEffect(() => {
    const handler = (e) => {
      if (codeMenuRef.current && !codeMenuRef.current.contains(e.target)) {
        setCodeMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mobile.trim()) {
      toast.error('Mobile number is required');
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      toast.error('Passwords do not match!');
      return;
    }

    if (formData.password.length < 6) {
      toast.error('Password must be at least 6 characters long');
      return;
    }

    setLoading(true);
    // Combine country code with mobile number
    const submissionData = {
      ...formData,
      mobile: `${countryCode}${formData.mobile}`
    };
    const result = await register(submissionData, false);

    if (result.success) {
      navigate('/login');
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-[560px]">
        <div className="auth-card px-7 py-9 sm:px-10">
          <Link to="/" className="auth-back">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
            {t('backHome')}
          </Link>
          <h1 className="text-[1.75rem] font-medium text-gray-900 tracking-tight">{t('createAccount')}</h1>
          <p className="mt-2 text-sm text-gray-500 leading-relaxed">
            {t('createLead')}
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="first_name" className={`block text-sm font-medium text-gray-700 mb-2 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>{t('firstName')}</label>
                <input id="first_name" type="text" name="first_name" required autoComplete="given-name" dir={dir} placeholder={t('firstName')} value={formData.first_name} onChange={handleChange} className="auth-input auth-input-plain" />
              </div>
              <div>
                <label htmlFor="last_name" className={`block text-sm font-medium text-gray-700 mb-2 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>{t('lastName')}</label>
                <input id="last_name" type="text" name="last_name" required autoComplete="family-name" dir={dir} placeholder={t('lastName')} value={formData.last_name} onChange={handleChange} className="auth-input auth-input-plain" />
              </div>
            </div>

            <div>
              <label htmlFor="email" className={`block text-sm font-medium text-gray-700 mb-2 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>{t('email')}</label>
              <input id="email" type="email" name="email" required autoComplete="email" dir={dir} placeholder={t('phEmail')} value={formData.email} onChange={handleChange} className="auth-input auth-input-plain" />
            </div>

            <div>
              <label htmlFor="mobile" className={`block text-sm font-medium text-gray-700 mb-2 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>{t('mobile')}</label>
              <div className="flex gap-3">
                {/* Custom country-code dropdown with flags */}
                <div className="relative shrink-0" ref={codeMenuRef}>
                  <button
                    type="button"
                    aria-label="Country code"
                    onClick={() => setCodeMenuOpen((o) => !o)}
                    className="auth-input auth-input-plain w-[118px] flex items-center justify-between gap-2 cursor-pointer"
                  >
                    <span className="flex items-center gap-1.5">
                      <Flag country={selectedCountry.country} />
                      <span>{selectedCountry.code}</span>
                    </span>
                    <svg className={`w-4 h-4 text-gray-400 transition-transform ${codeMenuOpen ? 'rotate-180' : ''}`}
                      fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {codeMenuOpen && (
                    <div className="absolute left-0 top-full mt-1 w-[260px] max-h-64 overflow-y-auto rounded-xl border border-gray-200 bg-white shadow-lg z-30 py-1">
                      {countryCodes.map((country) => {
                        const isSelected = country.country === selectedIso;
                        return (
                          <button
                            key={country.country}
                            type="button"
                            onClick={() => { setSelectedIso(country.country); setCodeMenuOpen(false); }}
                            className={`w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left transition ${
                              isSelected ? 'bg-purple-50 text-purple-700 font-medium' : 'text-gray-700 hover:bg-gray-50'
                            }`}
                          >
                            <Flag country={country.country} />
                            <span className="flex-1 truncate">{country.name}</span>
                            <span className="text-gray-400">{country.code}</span>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>

                <input id="mobile" type="tel" name="mobile" required autoComplete="tel-national" dir={dir} placeholder={t('mobileNumber')} value={formData.mobile} onChange={handleChange} pattern="[0-9]*" maxLength="15" className="auth-input auth-input-plain" />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="password" className={`block text-sm font-medium text-gray-700 mb-2 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>{t('password')}</label>
                <input id="password" type="password" name="password" required autoComplete="new-password" dir={dir} placeholder={t('phPasswordMin')} value={formData.password} onChange={handleChange} className="auth-input auth-input-plain" />
              </div>
              <div>
                <label htmlFor="password_confirmation" className={`block text-sm font-medium text-gray-700 mb-2 ${dir === 'rtl' ? 'text-right' : 'text-left'}`}>{t('confirmPassword')}</label>
                <input id="password_confirmation" type="password" name="password_confirmation" required autoComplete="new-password" dir={dir} placeholder={t('phRepeatPassword')} value={formData.password_confirmation} onChange={handleChange} className="auth-input auth-input-plain" />
              </div>
            </div>

            <label htmlFor="terms" className="flex items-start gap-3 text-sm text-gray-600">
              <input id="terms" type="checkbox" required className="mt-1 h-4 w-4 rounded border-gray-300 text-purple-700" />
              <span>
                {t('agreeBefore')}{' '}
                <Link to="/terms" className="text-purple-700 hover:underline">{t('terms')}</Link>
                {' '}{t('agreeMid')}{' '}
                <Link to="/privacy" className="text-purple-700 hover:underline">{t('privacy')}</Link>
                {' '}{t('agreeAfter')}
              </span>
            </label>

            <button type="submit" disabled={loading} className="auth-submit">
              {loading ? t('creating') : t('createAccount')}
            </button>
          </form>

          <p className="mt-7 pt-6 text-center text-sm text-gray-500 border-t border-[#f3f2f6]">
            {t('already')}{' '}
            <Link to="/login" className="nav-link font-medium text-purple-700 hover:text-purple-900">{t('signIn')}</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;

